import { Box, Stack, Tab, Tabs } from "@mui/material";
import ConfigCLiente from "./ConfigCliente";
import Aprovacao from "./Aprovacao";
import ConfigPausa from "./ConfigPausa";
import { useTranslation } from "react-i18next";
import { useState } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: "100%" }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Configuracoes() {
  const { t } = useTranslation("translation");
  const [value, setValue] = useState<number>(0);
  function handleChange(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  }

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} indicatorColor="secondary" textColor="secondary" scrollButtons="auto" centered>
          <Tab label={t("checklists.configCliente")} value={0} />
          <Tab label={t("checklists.configAprov")} value={1} />
          <Tab label={t("checklists.configPausa")} value={2} />
        </Tabs>
      </Box>
      <Stack direction="row" width="100%" spacing={5}>
        <CustomTabPanel value={value} index={0}>
          <ConfigCLiente />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Aprovacao />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <ConfigPausa />
        </CustomTabPanel>
      </Stack>
    </>
  );
}
